import React from 'react';
import HazardObservationForm from './HazardObservationForm';
import './index.css'; // Ensure Tailwind CSS is included

const App = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center">
      <HazardObservationForm />
    </div>
  );
};

export default App;